export const GenderData = [
    {
      label: "Male",
      value: "1",
    },
    {
      label: "Female",
      value: "2",
    } 
  ];


  export const IdTypeData = [
    {
      label: "PROMOTIONAL",
      value: "PROMOTIONAL",
    },
    {
      label: "TRANSACTIONAL",
      value: "TRANSACTIONAL",
    }
   
  ];

  export const instTypeData = [
    {
      label: "COMPANY",
      value: "COMPANY",
    },
    {
      label: "INDIVIDUAL",
      value: "INDIVIDUAL",
    } 
  ];
 
  export const ownershipData = [
    {
      label: "I want to share a service code with multiple users",
      value: "SHARED",
    },
    {
      label: "I want my own service code",
      value: "PRIVATE",
    } 
  ];


  export const costData = [
    {
      label: "The Customer",
      value: "CUSTOMER",
    },
    {
      label: "Me, as the owner of the service code",
      value: "ME",
    } 
  ];

  export const userData = [
    {
      label: "KAMAU",
      value: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    }, 
  ];

 
export const recurringBillsData = [
  {
    label: "Electricity",
    value: "Electricity",
  },
  {
    label: "Water",
    value: "Water",
  },
  {
    label: "Security",
    value: "Security",
  }, 
];

export const statusData = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  }, 
];

export const accessLevelData = [
  {
    label: "User",
    value: "USER",
  },
  {
    label: "Manager",
    value: "MANAGER",
  }, 
  {
    label: "Admin",
    value: "ADMIN",
  }, 
];

export const monthsData = [
  { label: "January", value: "1" },
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const leaveTypesData = [
  {
    label: "Annual",
    value: "AN",
  },
  {
    label: "Maternity",
    value: "MT",
  },
  {
    label: "Paternity",
    value: "PT",
  },
  {
    label: "Sick Leave",
    value: "SI",
  },
  {
    label: "Sick Off",
    value: "SO",
  },
  {
    label: "Compassionate Leave",
    value: "CP",
  },
  {
    label: "Home Leave",
    value: "HM",
  },
  {
    label: "Special Leave",
    value: "SP",
  },
  {
    label: "Sabbatical Leave",
    value: "SB",
  },
  {
    label: "Study Leave",
    value: "ST",
  },
  {
    label: "Leave of Absence",
    value: "LA",
  },
];


export const YesNoData = [
  {
    label: "Yes",
    value: 1,
  },
  {
    label: "No",
    value: 0,
  } 
];

export const dutyData = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  } 
];

export const paymentMethodsData = [
  {
    label: "Bank Payment",
    value: "BANK",
  },
  {
    label: "Mobile Payment",
    value: "MPESA",
  } 
];
export const attendanceTypeData = [
  {
    label: "CHECK_IN",
    value: "CHECK_IN",
  },
  {
    label: "CHECK_OUT",
    value: "CHECK_OUT",
  },
  {
    label: "OVERTIME_IN",
    value: "OVERTIME_IN",
  },
  {
    label: "OVERTIME_OUT",
    value: "OVERTIME_OUT",
  },
  {
    label: "TASK_LOG",
    value: "TASK_LOG",
  }    
];

export const typeData = [
  {
    label: "NORMALDAY",
    value: "NORMALDAY",
  },
  {
    label: "WEEKEND",
    value: "WEEKEND",
  }, 
];

export const walletsRoleData = [
  {
    label: "INITIATOR",
    value: "INITIATOR",
  },
  {
    label: "APPROVER",
    value: "APPROVER",
  }, 
];

export const userTitleData = [
  {
    label: "Normal",
    value: "Normal",
  },
  {
    label: "Supervisor",
    value: "Supervisor",
  }, 
];

export const userTypeData = [
  {
    label: "NORMAL",
    value: "NORMAL",
  },
  {
    label: "NDOVUHR_USE",
    value: "NDOVUHR_USE",
  }, 
];
 
export const itemStatusData = [
  {
    label: "GOOD",
    value: "GOOD",
  },
  {
    label: "BAD",
    value: "BAD",
  }, 
];
 
export const mvtTypeData = [
  {
    label: "POSITIVE",
    value: "POSITIVE",
  },
  {
    label: "NEGATIVE",
    value: "NEGATIVE",
  }, 
];

 
export const benefitTypeData = [
  {
    label: "medical limits",
    value: "medical limits",
  },
  {
    label: "mortgage",
    value: "mortgage",
  }, 
  {
    label: "car limits",
    value: "car limits",
  }, 
  {
    label: "last expenses",
    value: "last expenses",
  }, 
  {
    label: "other benefits",
    value: "other benefits",
  }, 
];

 export const paymentFrequency = [
    {
      label: "Daily",
      value: "Daily",
    },
    {
      label: "Weekly",
      value: "Weekly",
    },
    {
      label: "Monthly",
      value: "Monthly",
    },
  ];

  export const startPeriodOptions = [
    {
      label: "Immediately",
      value: "Immediately",
    },
    {
      label: "Two-weeks",
      value: "Two-weeks",
    },
    {
      label: "One-month",
      value: "One-month",
    },
  ];

    export const activityOptions = [
    {
      label: "Interview",
      value: "Interview",
    },
    {
      label: "Meeting",
      value: "Meeting",
    }, 
  ];
export const nationalityData = [
  { label: "Algerian", value: "Algerian" },
  { label: "Angolan", value: "Angolan" },
  { label: "Beninese", value: "Beninese" },
  { label: "Botswanan", value: "Botswanan" },
  { label: "Burkinabe", value: "Burkinabe" },
  { label: "Burundian", value: "Burundian" },
  { label: "Cameroonian", value: "Cameroonian" },
  { label: "Cape Verdean", value: "Cape Verdean" },
  { label: "Central African", value: "Central African" },
  { label: "Chadian", value: "Chadian" },
  { label: "Comorian", value: "Comorian" },
  { label: "Congolese (Congo-Brazzaville)", value: "Congolese (Congo-Brazzaville)" },
  { label: "Congolese (DRC)", value: "Congolese (DRC)" },
  { label: "Djiboutian", value: "Djiboutian" },
  { label: "Egyptian", value: "Egyptian" },
  { label: "Equatorial Guinean", value: "Equatorial Guinean" },
  { label: "Eritrean", value: "Eritrean" },
  { label: "Ethiopian", value: "Ethiopian" },
  { label: "Gabonese", value: "Gabonese" },
  { label: "Gambian", value: "Gambian" },
  { label: "Ghanaian", value: "Ghanaian" },
  { label: "Guinean", value: "Guinean" },
  { label: "Bissau-Guinean", value: "Bissau-Guinean" },
  { label: "Ivorian", value: "Ivorian" },
  { label: "Kenyan", value: "Kenyan" },
  { label: "Lesotho", value: "Lesotho" },
  { label: "Liberian", value: "Liberian" },
  { label: "Libyan", value: "Libyan" },
  { label: "Malagasy", value: "Malagasy" },
  { label: "Malawian", value: "Malawian" },
  { label: "Malian", value: "Malian" },
  { label: "Mauritanian", value: "Mauritanian" },
  { label: "Mauritian", value: "Mauritian" },
  { label: "Moroccan", value: "Moroccan" },
  { label: "Mozambican", value: "Mozambican" },
  { label: "Namibian", value: "Namibian" },
  { label: "Nigerien", value: "Nigerien" },
  { label: "Nigerian", value: "Nigerian" },
  { label: "Rwandan", value: "Rwandan" },
  { label: "Sao Tomean", value: "Sao Tomean" },
  { label: "Senegalese", value: "Senegalese" },
  { label: "Seychellois", value: "Seychellois" },
  { label: "Sierra Leonean", value: "Sierra Leonean" },
  { label: "Somali", value: "Somali" },
  { label: "South African", value: "South African" },
  { label: "South Sudanese", value: "South Sudanese" },
  { label: "Sudanese", value: "Sudanese" },
  { label: "Swazi", value: "Swazi" },
  { label: "Tanzanian", value: "Tanzanian" },
  { label: "Togolese", value: "Togolese" },
  { label: "Tunisian", value: "Tunisian" },
  { label: "Ugandan", value: "Ugandan" },
  { label: "Zambian", value: "Zambian" },
  { label: "Zimbabwean", value: "Zimbabwean" }
];

 